var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.c()},_vm._l((_vm.options),function(option){return _c('answer-option',_vm._b({key:option.id,attrs:{"html-value":String(option.id),"required":""},model:{value:(_vm.optionId),callback:function ($$v) {_vm.optionId=$$v},expression:"optionId"}},'answer-option',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(option.text)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }